const Questions = () => {
  return (
    <div className=" text-justify mx-3 mb-8 pb-8">
      <div className=" my-4">
        <p className=" text-gray-6 my-2">
          1-چطور می توانم محصول خودم را در حجره بفروشم؟
        </p>
        <p className=" text-primary text-sm">
          می توانید در بخش ثبت آگهی، با وارد کردن اطلاعات و قیمت و تصویرمحصول
          خود، آگهی فروش ثبت کنید و با خریداران ارتباط برقرار کنید
        </p>
      </div>

      <div className=" my-4">
        <p className=" text-gray-6 my-2 ">
          2-چرا آگهی‌ها نیاز به تایید برای انتشار دارند؟
        </p>
        <p className=" text-primary text-sm">
          ما موظفیم تا مطمئن شویم که آگهی‌های منتشر شده با موازین قانونی مغایرتی
          نداشته باشد تا محیطی مناسب برای انجام معاملات مختلف در حوزه کشاورزی
          شکل گیرد.
        </p>
      </div>
      <div className=" my-4">
        <p className=" text-gray-6 my-2">3-چرا آگهی من رد شده است؟ </p>
        <p className=" text-primary text-sm">
          ممکن است در متن یا عکس آگهی ثبت شده شما مغایرتی با قوانین و مقررات
          بازار وجود داشته است یا کالای ثبت شده در آگهی شما در دسته اشتباه قرار
          گرفته باشد که در این صورت آگهی توسط کارشناسان رد می شود.
        </p>
      </div>
      <div className=" my-4">
        <p className=" text-gray-6 my-2">
          4-حجره مزرعه چه منافعی در معاملات خواهد داشت؟
        </p>
        <p className=" text-primary text-sm">
          ما هیچ منفعتی از معاملات شما نخواهیم داشت و مزرعه فقط محیطی برای
          انتشار آگهی و ثبت نیازمندی است. به همین خاطر نیز مسئولیتی در قبال
          معاملات انجام شده نخواهیم داشت و از کاربران درخوااست می شود که قبل از
          انجام معاله قوانین و مقررات را مطالعه نمایند.
        </p>
      </div>
      <div className=" my-4">
        <p className=" text-gray-6 my-2">
          5-آیا برای ثبت آگهی باید هزینه پرداخت کنم؟
        </p>
        <p className=" text-primary text-sm">
          خیر. ثبت آگهی کاملا رایگان است اما شما با خرید بسته‌های ارتقا آگی
          می‌توانید به دیده شدن و فروش بیشتر دست یابید.
        </p>
      </div>
      <div className=" my-4">
        <p className=" text-gray-6 my-2">
          6-چرا من نمی توانم آگهی جدید ثبت کنم؟
        </p>
        <p className=" text-primary text-sm">
          ممکن است گزارش تخلف از سمت دیگر کاربران علیه شما ثبت شده باشد. در این
          صورت تا تعیین تکلیف شکایات و نظرات ثبت شده و گزارش‌های کاربران توسط
          کارشناسان ما، فعالیت شما در حجره مزرعه تعلیق می شود.
        </p>
      </div>
      <div className=" my-4">
        <p className=" text-gray-6 my-2">
          7-فعالیت در این فضا چه مزیتی برای کسب و کار من دارد؟
        </p>
        <p className=" text-primary text-sm">
          شما چه کشاورز باشید چه عمده فروش، این سامانه بستری تخصصی برای
          فعالیت‌های شماست. به دلیل اینکه فناوری‌های به کار رفته در سامانه،
          نیازهای کشاورزان و عمده فروشان را بطور هوشمند بررسی کرده است.
        </p>
      </div>
    </div>
  );
};

export default Questions;
